import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

export default function Services() {
    const [services, setServices] = useState([]);
    useEffect(() => {
        api.get("/services").then((r) => setServices(r.data)).catch(() => {});
    }, []);
    return (
        <div data-testid="services-page">
            <section className="relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-b from-ink-800 to-ink-900" />
                <div className="relative mx-auto max-w-7xl px-6 md:px-12 py-28 md:py-36">
                    <div className="label-tag">Capabilities</div>
                    <h1 className="mt-4 font-display text-5xl md:text-6xl font-black tracking-tight max-w-3xl">
                        One firm. Every lever a union needs.
                    </h1>
                    <p className="mt-6 text-white/70 max-w-2xl text-lg">
                        Whether you're filing a grievance tomorrow or planning a year-long
                        organizing drive, each engagement begins with a plain-language scope
                        and ends with measurable results.
                    </p>
                </div>
            </section>

            <section className="pb-28">
                <div className="mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {services.map((s, i) => (
                        <Link
                            key={s.slug}
                            to={`/services/${s.slug}`}
                            data-testid={`service-card-${s.slug}`}
                            className="group relative rounded-2xl bg-ink-800 border border-white/10 gold-glow transition-all p-8 min-h-[280px] flex flex-col"
                        >
                            <div className="label-tag">0{String(i + 1).padStart(2, "0")}</div>
                            <h2 className="mt-4 font-display text-2xl font-bold leading-tight">
                                {s.title}
                            </h2>
                            <p className="mt-3 text-gold-500 text-sm italic">{s.tagline}</p>
                            <p className="mt-4 text-white/60 text-sm leading-relaxed">
                                {s.summary}
                            </p>
                            <div className="mt-auto pt-6 flex items-center gap-2 text-gold-500 text-xs uppercase tracking-[0.25em]">
                                Learn more
                                <ArrowUpRight size={14} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
}
